import {
    AosSeverity,
    recurringTaskSeverities,
    severityToneMap,
    taskSeverities,
    translateTaskSeverity,
} from 'aos-services/src/services/common/types/AosSeverity'
import { TaskFormPayload } from 'aos-services/src/services/tasks/types/payload/TaskFormPayload'
import { TaskProcessType } from 'aos-services/src/services/tasks/types/TaskProcessType'
import { ChipSeverity } from 'aos-ui-universal'
import React from 'react'
import { Controller, useController, useFormContext, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { TaskOrTemplatePayload } from '../../../utils'
import { TaskFormField } from '../TaskFormField'

export const TaskSeverityField = () => {
    const { t: translate } = useTranslation()
    const { control } = useFormContext<TaskOrTemplatePayload>()
    const task = useWatch({ control }) as TaskFormPayload
    const processTypeField = useController({ control, name: 'processType' })
    const recurrenceField = useController({ control, name: 'recurrence' })

    const isRecurring = Boolean(task.parentTaskId || task.recurrence)

    return (
        <Controller
            control={control}
            name='severity'
            render={({ field, fieldState }) => (
                <TaskFormField
                    label={translate('form.severity.label', { ns: 'tasks' })}
                    required
                    error={
                        fieldState.error
                            ? translate('form.severity.error', { ns: 'tasks' })
                            : undefined
                    }
                >
                    <div className='grid grid-cols-3 gap-2'>
                        {taskSeverities.map(s => (
                            <ChipSeverity
                                key={s}
                                className='w-full'
                                label={translateTaskSeverity(translate)(s)}
                                tone={severityToneMap[s]}
                                isSelected={field.value === s}
                                isDisabled={isRecurring && !recurringTaskSeverities.includes(s)}
                                onPress={() => {
                                    if (s === AosSeverity.Emergency) {
                                        if (task.processType === TaskProcessType.Seasonal) {
                                            processTypeField.field.onChange(TaskProcessType.Daily)
                                        }
                                        recurrenceField.field.onChange(undefined)
                                    }
                                    field.onChange(s)
                                }}
                            />
                        ))}
                    </div>
                </TaskFormField>
            )}
        />
    )
}
